import React from "react";
import logo from "./../../../../assets/icons/seven-tri-bg.png";

const Modal = ({ title, content, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
      <div className="modal-container w-80 max-w-[90vw] rounded-2xl -mt-[350px] shadow-lg border border-[#228B22]/20 overflow-hidden">
        <div className="flex bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] justify-start items-center modal-header text-lg text-white relative">
          <div className="relative z-10 flex items-center p-4">
            <div className="w-12 h-12 bg-white/20 rounded-md flex items-center justify-center mr-3">
              <img className="w-8 h-8" src={logo} alt="logo" />
            </div>
            <div>
              <h2 className="font-bold">{title.toUpperCase()}</h2>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-[#FFD700] rounded-full mr-2"></div>
                <span className="text-xs text-emerald-100">System Message</span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-white to-[#EAEAEA]">
          <div className="flex justify-center modal-body p-6">
            <p className="text-gray-800 font-semibold text-center leading-relaxed">{content}</p>
          </div>
          <div className="modal-footer pb-6 flex justify-center">
            <button
              className="bg-gradient-to-r from-[#FFD700] to-yellow-400 text-gray-900 font-bold py-3 px-8 rounded-xl border border-yellow-300 active:opacity-90"
              onClick={onClose}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
